import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";
import { hotKeywords } from "@/mocks/keywords";

export default function SiteFooter() {
  const topKeywords = [...hotKeywords].sort((a, b) => b.heat - a.heat).slice(0, 8);

  return (
    <footer className="mt-16 bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-search-eye-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.slogan}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-accent-400" />
              <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-accent-300">
                {siteInfo.email}
              </a>
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-sm font-semibold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-background-300 transition-colors hover:text-accent-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="分类导航">
            <h4 className="text-sm font-semibold text-background-50">主题分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-background-300 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-semibold text-background-50">热门黑料词</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {topKeywords.map((keyword) => (
                <Link
                  key={keyword.word}
                  to={`/keywords?q=${encodeURIComponent(keyword.word)}`}
                  className="rounded-full border border-background-700 px-3 py-1 text-xs text-background-300 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  {keyword.word}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.name}. 本站为关键词索引工具，词条内容仅为公开讨论线索整理。</p>
          <p>自 {siteInfo.since} 年起持续整理 · 站内人物与事件均为虚构设定</p>
        </div>
      </div>
    </footer>
  );
}